<template>
    <div class="d-flex-grow justify-center">
        <div class="d-flex flex-column w-100 w-md-50rem max-w-100">
            <div class="pb-6" v-if="invoicePaymentRequest.length">
                <v-card>
                    <v-table rounded="lg">
                        <thead>
                            <tr>
                                <th>Inv Code</th>
                                <th>Admin</th>
                                <th>Settled Amount</th>
                                <th>Status</th>
                                <th>Date</th>
                            </tr>
                            
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in invoicePaymentRequest" :key="index">
                                <td>{{ item.invoice?.invoice_code }}</td>
                                <td>
                                    <div>
                                        {{ item.invoice?.user?.name }}
                                    </div>
                                    <div class="text-secondary font-italic fs-n5">
                                        {{ item.invoice?.user?.email }}
                                    </div>
                                </td>
                                <td>{{ helpers.moneyFormatNew(item.amount) }}</td>
                                <td>{{ item.status }}</td>
                                <td>{{ item.created_at }}</td>
                            </tr>
                        </tbody>
                    </v-table>
                </v-card>
            </div>
            <v-form @submit.prevent="store" class="">
                <v-card class="d-flex-col-grow">
                    <v-card-text class="flex-grow-1">
                        <div class="d-flex flex-column ga-7">
                            <div class="fs-2 fw-medium">
                                Payment Information
                            </div>
                            <div v-if="form.errors.custom_error" class="fs-1 text-error">
                                {{ form.errors.custom_error }}
                            </div>
                            <div>
                                <v-text-field-v1
                                    label="Name"
                                    v-model="formReadonly.name"
                                    readonly
                                ></v-text-field-v1>
                            </div>
                            <div>
                                <v-row>
                                    <v-col cols="12" md="6">
                                        <div>
                                            <v-text-field-v1
                                                label="Amount"
                                                v-model="formReadonly.amount"
                                                readonly
                                            >
                                                <template #append-inner>
                                                    <span>USD</span>
                                                </template>
                                            </v-text-field-v1>
                                        </div>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <div>
                                            <v-text-field-v1
                                                label="Method"
                                                v-model="formReadonly.payment_method_preview"
                                                readonly
                                            ></v-text-field-v1>
                                        </div>
                                    </v-col>
                                    
                                    <v-col  cols="12"  md="6" v-if="formReadonly.payment_method == 'crypto'">
                                        <div>
                                            <v-text-field-v1
                                                label="Coin"
                                                v-model="formReadonly.additional_data.coin"
                                                readonly
                                            ></v-text-field-v1>
                                        </div>
                                    </v-col>
                                    <v-col v-if="formReadonly.payment_method == 'crypto' || formReadonly.payment_method == 'usdt'">
                                        <div>
                                            <v-text-field-v1
                                                label="Wallet Address"
                                                v-model="formReadonly.additional_data.address"
                                                readonly
                                            ></v-text-field-v1>
                                        </div>
                                    </v-col>
                                    <v-col cols="12" v-if="formReadonly.payment_method == 'wire'">
                                        <div>
                                            <v-textarea-v1
                                                label="Wire Info"
                                                rows="3"
                                                v-model="formReadonly.additional_data.wireInfo"
                                                readonly
                                            ></v-textarea-v1>
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <div>
                                            <v-textarea-v1
                                                label="Comments"
                                                v-model="formReadonly.comments"
                                                rows="5"
                                                readonly
                                            ></v-textarea-v1>
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <div class="well">
                                            <v-switch-v1
                                                label="Completed"
                                                v-model="form.completed"
                                                density="compact"
                                                :readonly="formReadonly.completed"
                                                :error-messages="form.errors.reference"
                                            ></v-switch-v1>
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <div>
                                            <v-textarea-v1
                                                label="Reference"
                                                v-model="form.reference"
                                                rows="5"
                                                :error-messages="form.errors.reference"
                                            ></v-textarea-v1>
                                        </div>
                                    </v-col>
                                </v-row>
                            </div>
                            <div v-if="form.errors.custom_error" class="fs-1 pb-2 text-error">
                                {{ form.errors.custom_error }}
                            </div>
                        </div>
                    </v-card-text>
                    <v-card-actions-form>
                        <div class="d-flex flex-grow-1 justify-space-between">
                            <v-btn-input-compact color="btn-secondary" @click="helpers.goBack">
                                <template #prepend>
                                    <mdi-icon>chevron_left</mdi-icon>
                                </template>
                                Back
                            </v-btn-input-compact>
                            <v-btn-input-compact type="submit" :disabled="form.processing" :loading="form.processing">
                                <template #prepend>
                                    <mdi-icon>check</mdi-icon>
                                </template>
                                Save
                            </v-btn-input-compact>
                        </div>
                        
                    </v-card-actions-form>
                </v-card>
            </v-form>
            
        </div>
         
     </div>
 </template>
 <script setup lang="ts">
     import { ref } from "vue";
     import { useForm, usePage, router } from '@inertiajs/vue3';
     import { toast } from 'vue3-toastify';
     import { SharedPage, SharedPageProps } from '@/Types/inertia';
     import { User } from '@/Types/Models/user';
     import helpers from '@/Plugins/helpers';
     import { pageTitle, containerGapForForm } from '@/Composables/PageMeta';
     import { Company } from "@/Types/Models/company";
     import { PaymentRequest, PaymentRequest_Method_Map } from "@/Types/Models/payment-request";
     import { useDate } from 'vuetify';
     import { useAuth } from '@/Composables/Auth';
    import { InvoicePaymentRequest } from "@/Types/Models/invoice-payment-request";

 
     pageTitle.value = 'Payment Request';
     containerGapForForm();
     interface PageData extends SharedPageProps{
         data?:{
            paymentRequest: PaymentRequest,
            paymentMethods: PaymentRequest_Method_Map,
            invoicePaymentRequest: InvoicePaymentRequest[],
            success_redirect?: string
         }
     }

     interface Form extends PaymentRequest{
         custom_error: string,
         success_redirect: string,
         completed: boolean
         reference: string | null
     }
 
     const page = usePage<PageData>();
     const paymentRequest = ref<PaymentRequest>(page.props.data?.paymentRequest ?? {} as PaymentRequest);
     const invoicePaymentRequest = ref<InvoicePaymentRequest[]>(page.props.data?.invoicePaymentRequest ?? []);
     
     const formReadonly = ref({
        name: paymentRequest.value.name ?? null,
        payment_method: paymentRequest.value.payment_method ?? null,
        payment_method_preview: paymentRequest.value.payment_method_preview?.name ?? null,
        amount: helpers.numberFormatter(paymentRequest.value.amount ?? 0, 8),
        comments: paymentRequest.value.comments ?? null,
        additional_data: {
            address: paymentRequest.value.additional_data?.address ?? null,
            coin: paymentRequest.value.additional_data?.coin ?? null,
            wireInfo: paymentRequest.value.additional_data?.wireInfo ?? null,
        },
        completed: paymentRequest.value?.completed ?? false,
     });
     const form = useForm<Form>({
         custom_error: '',
         id: paymentRequest.value?.id ?? 0,
         completed: paymentRequest.value?.completed ?? false,
         reference: paymentRequest.value?.reference ?? '',
         
         success_redirect: page.props.data?.success_redirect ?? '',
     });

 
     const store = async () => {
        form.clearErrors();
        form.post(route('paymentRequests.superadmin.store', paymentRequest.value?.id ?? 0), {
                preserveState: true,
                onSuccess: (page: SharedPage) => {
                    toast.success(page.props?.jetstream?.flash?.msg?.text ?? 'Payment request is saved');
                    form.clearErrors();
                },
                onFinish: (visit) => {
                    // console.log('visit onFinish', visit);
                },
                onError: (errors) => {
                    console.log('onError', errors);
                }
        });
     }
 </script>